import type {PublicOption, VotingSystem} from '../../../shared/ballotTypes';
import {PaperButton} from '../../../shared/sticker/stickers';
import type {BallotPicks} from '../ballotState';

const rows = (system: VotingSystem, picks: BallotPicks, options: PublicOption[]) =>
    options
        .filter((option) => option.id in picks)
        .sort((a, b) => picks[a.id] - picks[b.id])
        .map((option) => ({
            id: option.id,
            title: option.title,
            mark:
                system === 'preferential'
                    ? `${picks[option.id]}.`
                    : system === 'dots'
                      ? `x${picks[option.id]}`
                      : '',
        }));

export const ConfirmSheet = ({
    system,
    picks,
    options,
    sending,
    onSubmit,
    onBack,
}: {
    system: VotingSystem;
    picks: BallotPicks;
    options: PublicOption[];
    sending: boolean;
    onSubmit: () => void;
    onBack: () => void;
}) => (
    <div className="ph-overlay ph-overlay--bottom">
        <div className="ph-sheet" role="dialog" aria-modal="true" aria-labelledby="ph-sheet-title">
            <p className="ph-tag">Check your vote</p>
            <h2 id="ph-sheet-title" className="ph-title">
                Sure?
            </h2>
            <ul className="ph-picklist">
                {rows(system, picks, options).map((row) => (
                    <li key={row.id}>
                        <span className="ph-picklist__mark">{row.mark}</span>
                        <b>{row.title}</b>
                    </li>
                ))}
            </ul>
            <p className="ph-muted">You can't change it after submitting.</p>
            <PaperButton className="ph-wide" disabled={sending} onClick={onSubmit}>
                Submit
            </PaperButton>
            <PaperButton variant="ghost" className="ph-wide" disabled={sending} onClick={onBack}>
                Go back
            </PaperButton>
        </div>
    </div>
);
